import { render, staticRenderFns } from "./CreateRewardForm.vue?vue&type=template&id=6a0d9a92"
import script from "./CreateRewardForm.vue?vue&type=script&lang=js"
export * from "./CreateRewardForm.vue?vue&type=script&lang=js"
import style0 from "./CreateRewardForm.vue?vue&type=style&index=0&id=6a0d9a92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports